import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { useState } from 'react';
import searchFill from '@iconify/icons-eva/search-fill';
import { experimentalStyled as styled, alpha } from '@material-ui/core/styles';
import { Box, Input, Slide, Button, InputAdornment, ClickAwayListener } from '@material-ui/core';
import { MIconButton } from '../../@material-extend/MIconButton';
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;
const SearchbarStyle = styled('div')(({ theme }) => ({
    top: 0,
    left: 0,
    zIndex: 99,
    width: '100%',
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    height: APPBAR_MOBILE,
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
    padding: theme.spacing(0, 3),
    boxShadow: theme.customShadows.z8,
    backgroundColor: `${alpha(theme.palette.background.default, 0.72)}`,
    [theme.breakpoints.up('md')]: {
        height: APPBAR_DESKTOP,
        padding: theme.spacing(0, 5),
    },
}));
export function Searchbar() {
    const [isOpen, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen((prev) => !prev);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (_jsx(ClickAwayListener, Object.assign({ onClickAway: handleClose }, { children: _jsxs("div", { children: [!isOpen && (_jsx(MIconButton, Object.assign({ onClick: handleOpen }, { children: _jsx(Icon, { icon: searchFill, width: 20, height: 20 }, void 0) }), void 0)), _jsx(Slide, Object.assign({ direction: "down", in: isOpen, mountOnEnter: true, unmountOnExit: true }, { children: _jsxs(SearchbarStyle, { children: [_jsx(Input, { autoFocus: true, fullWidth: true, disableUnderline: true, placeholder: "Search\u2026", startAdornment: _jsx(InputAdornment, Object.assign({ position: "start" }, { children: _jsx(Box, { component: Icon, icon: searchFill, sx: { color: 'text.disabled', width: 20, height: 20 } }, void 0) }), void 0), sx: { mr: 1, fontWeight: 'fontWeightBold' } }, void 0), _jsx(Button, Object.assign({ variant: "contained", onClick: handleClose }, { children: "Search" }), void 0)] }, void 0) }), void 0)] }, void 0) }), void 0));
}
//# sourceMappingURL=Searchbar.js.map